<!-- DeleteOppModal.vue -->

<template>

  <div class="modal" id="deleteOppModal" tabindex="-1" aria-labelledby="deleteOppModalLabel" aria-hidden="true" ref="deleteOppModal">
    <div class="modal-dialog">

      <div class="modal-content shadow shadow-lg">
        <div class="modal-header border-bottom">
          <h5 class="modal-title">Delete Opp</h5>
          <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
        </div>

        <div class="modal-body">
          Are you sure you want to delete this opp?
        </div>

        <div class="modal-footer">
          <span v-if="isDeleting('deletingOpp')" class="ms-2 spinner-border spinner-border-sm text-secondary" role="status" aria-hidden="true"></span>
          <button type="button" class="btn btn-outline-secondary" data-bs-dismiss="modal">Cancel</button>
          <button type="button" class="btn btn-danger" @click="deleteRecord" :disabled="isDeleting('deletingOpp') || isSubmitting">Delete</button>
        </div>
      </div>

    </div>
  </div>

</template>

<script>
/* global bootstrap */
import { mapGetters } from 'vuex';

export default {
  name: 'DeleteOppModal',
  emits: [
    'showAlert',
    'showError',
  ],
  props: {
    oppId: {
      type: String,
      required: true,
    },
  },

  data() {
    return {
      isSubmitting: false,
      modalInstance: null,
    };
  },

  computed: {
    ...mapGetters([
      'isCreating',
      'isFetching',
      'isUpdating',
      'isDeleting',
      'getProperty',
    ]),
  },

  watch: { },

  methods: {
    openModal() {
      if (!this.modalInstance) {
        const modalElement = this.$refs.deleteOppModal;
        this.modalInstance = new bootstrap.Modal(modalElement);
      }
      this.modalInstance.show();
    },

    closeModal() {
      if (this.modalInstance) {
        this.modalInstance.hide();
      }
    },

    async deleteRecord() {
      this.isSubmitting = true;

      try {
        await this.$store.dispatch('deleteRecord', {
          tableName: 'Opportunities',
          recordId: this.oppId,
          deletingStateVariable: 'deletingOpp',
        });

        this.$emit('showAlert', 'success', 'Successfully deleted opp');
        this.closeModal();
        this.$router.push('/');

      } catch (error) {
        this.$emit('showAlert', 'danger', 'Error deleting opp: ' + error.message);
        console.error('Error deleting opp: ', error);

      } finally {
        this.isSubmitting = false;
      }
    },
  },

  async mounted() { },

  created() { },
};
</script>